// extracted by mini-css-extract-plugin
export default {"container":"SubmissionPreview_container__lcGTG"};